import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
export function Pill({ tone = "neutral", dot, className, children }) {
    return (_jsx("span", { className: clsx("pill", `pill-${tone}`, dot && "pill-dot", className), children: children }));
}
//# sourceMappingURL=Pill.js.map